"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSeverity = exports.Integrations = exports.SpringLogger = void 0;
const ReactSentryLogger_1 = __importDefault(require("./src/modules/ReactSentryLogger"));
const TSeverity_1 = require("./src/types/TSeverity");
Object.defineProperty(exports, "TSeverity", { enumerable: true, get: function () { return TSeverity_1.TSeverity; } });
const dotenv = __importStar(require("dotenv"));
dotenv.config();
class SpringLogger {
    /**
     * Initialize Logger API instance
     * @param springLogger instance of a Logger API
     */
    static init(springLogger) {
        if (!SpringLogger._enabled)
            return false;
        globalThis.gLogger = springLogger; // Sets gobally object initialized 
        springLogger.initWrapper();
        return true;
    }
    /**
     * Writes a log with the specified severity
     * @param message log message
     * @param data optional data to be showed
     * @param severity optional log severity defined by TSeverity
     * @returns TSeverity
     */
    static log(message, ...args) {
        if (!SpringLogger._enabled)
            return;
        let errorMessage;
        const optionalParameters = {};
        if (message instanceof Error) {
            errorMessage = message.stack ? message.stack : message.message;
        }
        else {
            errorMessage = message.toString();
        }
        args.forEach(arg => {
            if (arg === TSeverity_1.TSeverity.DEBUG ||
                arg === TSeverity_1.TSeverity.INFO ||
                arg === TSeverity_1.TSeverity.WARNING ||
                arg === TSeverity_1.TSeverity.ERROR ||
                arg === TSeverity_1.TSeverity.FATAL) {
                optionalParameters.severity = arg;
                return;
            }
            optionalParameters.data = arg;
        });
        const type = optionalParameters.severity ? optionalParameters.severity : TSeverity_1.TSeverity.INFO;
        if (globalThis.gLogger) {
            if (optionalParameters.data)
                globalThis.gLogger.writeLog(message, type, optionalParameters.data);
            else
                globalThis.gLogger.writeLog(message, type);
        }
        if (!SpringLogger._console)
            return type;
        switch (type) {
            case TSeverity_1.TSeverity.FATAL:
            case TSeverity_1.TSeverity.ERROR:
                if (optionalParameters.data)
                    console.error(errorMessage, optionalParameters.data);
                else
                    console.error(errorMessage);
                break;
            case TSeverity_1.TSeverity.WARNING:
                if (optionalParameters.data)
                    console.warn(errorMessage, optionalParameters.data);
                else
                    console.warn(errorMessage);
                break;
            case TSeverity_1.TSeverity.DEBUG:
                if (optionalParameters.data)
                    console.debug(errorMessage, optionalParameters.data);
                else
                    console.debug(errorMessage);
                break;
            case TSeverity_1.TSeverity.INFO:
                if (optionalParameters.data)
                    console.info(errorMessage, optionalParameters.data);
                else
                    console.info(errorMessage);
                break;
            default:
                if (optionalParameters.data)
                    console.log(errorMessage, optionalParameters.data);
                else
                    console.log(errorMessage);
                break;
        }
        return type;
    }
    /**
     * Writes a info log
     * @param message error message or error exception instance
     * @param data optional data to be recorded
     * @returns TSeverity
     */
    static info(message, data) {
        return SpringLogger.log(message, data, TSeverity_1.TSeverity.INFO);
    }
    /**
     * Writes a debug log
     * @param message error message or error exception instance
     * @param data optional data to be recorded
     * @returns TSeverity
     */
    static debug(message, data) {
        return SpringLogger.log(message, data, TSeverity_1.TSeverity.DEBUG);
    }
    /**
     * Writes a warning log
     * @param message error message or error exception instance
     * @param data optional data to be recorded
     * @returns TSeverity
     */
    static warning(message, data) {
        return SpringLogger.log(message, data, TSeverity_1.TSeverity.WARNING);
    }
    /**
     * Writes a fatal error log
     * @param message error message or error exception instance
     * @param data optional data to be recorded
     * @returns TSeverity
     */
    static error(message, data) {
        return SpringLogger.log(message, data, TSeverity_1.TSeverity.ERROR);
    }
    /**
     * Defines the start point of a snipped code execution
     * @param name transaction name
     */
    static start(name) {
        if (!SpringLogger._enabled || !globalThis.gLogger)
            return;
        globalThis.gLogger.startTransaction(name);
    }
    /**
     * Defines the end point of a snipped code execution
     * @returns Execution time, -1 if something wrong happened
     */
    static finish(name) {
        if (!SpringLogger._enabled || !globalThis.gLogger)
            return -1;
        const transaction = globalThis.gLogger.finishTransaction(name);
        if (SpringLogger._console) {
            SpringLogger.log(transaction.name + ", End Timestamp: ", transaction.startTimestamp, TSeverity_1.TSeverity.DEBUG);
            SpringLogger.log(transaction.name + ", End Timestamp: ", transaction.endTimestamp, TSeverity_1.TSeverity.DEBUG);
            SpringLogger.log(transaction.name + ", Execution Time: ", transaction.executionTime, TSeverity_1.TSeverity.DEBUG);
        }
        return transaction.executionTime;
    }
}
exports.SpringLogger = SpringLogger;
SpringLogger._enabled = process.env.SPRING_LOGGER_ENABLED === undefined || process.env.SPRING_LOGGER_ENABLED === "true";
SpringLogger._console = process.env.SPRING_LOGGER_CONSOLE === "true";
// All external API implementations
const Integrations = {
    ReactSentryLogger: ReactSentryLogger_1.default // Sentry API for react
};
exports.Integrations = Integrations;
//# sourceMappingURL=index.js.map